<section modalContainer mode="modal">
  <section class="z-10 flex justify-end w-full p-4">
    <button>
      <app-icon
        (click)="close()"
        name="material-symbols:close-rounded"
        class="text-gray-700 cursor-pointer"
      />
    </button>
  </section>
  <section
    class="flex flex-col justify-start gap-6 px-8 md:pb-8 md:pt-0 py-[30px]"
  >
    <div class="flex flex-col items-center justify-center gap-3">
      <div class="flex items-center justify-center w-20">
        <img class="w-full" src="icons/logo.svg" alt="" />
      </div>
      <h1 class="text-[32px] font-bold text-gray-900">로그인</h1>
    </div>
    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-center">
        <img src="images/login-message.svg" alt="" />
      </div>
      <button
        type="button"
        style="background: #fee500"
        class="relative flex items-center justify-center py-3 rounded-xl"
        (click)="login()"
      >
        <img
          src="/icons/kakao.svg"
          class="absolute size-6 left-3 text-neutral-900"
        />
        <span class="text-sm font-bold">카카오로 시작</span>
      </button>
    </div>
    <div
      class="flex flex-col items-center gap-3 font-semibold text-neutral-500 *:text-xs *:md:text-sm"
    >
      <p>로그인하시면 아래 내용에 동의하는 것으로 간주됩니다.</p>
      <div class="flex justify-center gap-6 underline">
        <a
          (click)="close()"
          routerLink="/policy"
          [queryParams]="{ type: 'PRIVACY_CONSENT' }"
          >개인정보처리방침</a
        >
        <a
          (click)="close()"
          routerLink="/policy"
          [queryParams]="{ type: 'TERMS_OF_SERVICE' }"
        >
          이용약관</a
        >
      </div>
    </div>
  </section>
</section>
